{
  "page_title": "Tilläggstjänster",
  "calendar": {
    "make_booking": "Gör en bokning",
    "service": "Tjänst",
    "inactive": "Inte i bruk",
    "no_units": "Inga tjänster",
    "failed_to_load": "Det gick inte att ladda kalendern",
    "prev_day": "Föregående dag",
    "next_day": "Nästa dag",
    "margin": "Bokningsmarginal",
    "collapse_panel": "Minimera panelen",
    "expand_panel": "Expandera panelen",
    "show_group": "Visa {{name}}",
    "hide_group": "Dölj {{name}}",
    "booking": {
      "title": "Ny bokning",
      "mode_label": "Bokningssätt",
      "single_tab": "Enskild bokning",
      "batch_tab": "Massbokning",
      "type_label": "Bokningstyp",
      "type": {
        "service": "Service",
        "competition": "Tävling",
        "tee_time": "Starttid",
        "other": "Övrigt"
      },
      "group_label": "Tjänstegrupp",
      "unit_label": "Tjänst",
      "unit_placeholder_single": "Välj tjänst",
      "unit_placeholder_batch": "Välj tjänster",
      "selected_count": "{{count}} / {{total}} valda",
      "select_all_free": "Välj alla lediga",
      "no_units": "Inga tjänster",
      "status_free": "Ledig",
      "status_busy": "Bokad",
      "start": "Börjar",
      "end": "Slutar",
      "duration_label": "Varaktighet",
      "holes9": "9 hål ({{min}} min)",
      "holes18": "18 hål ({{min}} min)",
      "notes": "Ytterligare information",
      "notes_placeholder": "T.ex. kundens namn",
      "submit": "Gör en bokning",
      "created": "Bokning skapad",
      "save_failed": "Det gick inte att spara bokningen",
      "availability_failed": "Det gick inte att ladda tillgängligheten",
      "times_required": "Välj start- och sluttid",
      "invalid_window": "Sluttiden måste vara efter starttiden",
      "type_required": "Välj bokningstyp",
      "unit_required": "Välj tjänst",
      "units_required": "Välj minst en tjänst",
      "conflict_row": "{{unit}}: {{start}}–{{end}}",
      "overlap_warning": "Bokningen överlappar med en befintlig bokning."
    },
    "reservation": {
      "edit": "Redigera",
      "edit_title": "Redigera bokning",
      "updated": "Bokning uppdaterad",
      "update_failed": "Uppdatering av bokning misslyckades",
      "delete": "Ta bort",
      "delete_confirm_header": "Ta bort bokning",
      "delete_confirm_body": "Vill du verkligen ta bort bokningen {{name}}?",
      "delete_scope_single": "Endast denna bokning",
      "delete_scope_batch": "Alla bokningar i detta parti",
      "deleted": "Bokning borttagen",
      "batch_deleted": "Partiets bokningar borttagna",
      "delete_failed": "Borttagning av bokning misslyckades"
    },
    "resize": {
      "saved": "{{unit}}: bokningstiden har ändrats",
      "undo_failed": "Ångring misslyckades"
    },
    "prev_week": "Föregående vecka",
    "next_week": "Nästa vecka",
    "view_mode_label": "Kalendervy",
    "view_day": "Dag",
    "view_week": "Vecka",
    "pick_date": "Välj datum",
    "show_day": "Visa dagsvy"
  },
  "serviceGroups": {
    "panel_title": "Tjänstegrupper",
    "empty": {
      "heading": "Inga tjänstegrupper",
      "description": "Med tjänstegrupper hanterar du uthyrningsbara tilläggstjänster, som golfbilar, bags och vagnar.",
      "add_button": "Lägg till tjänstegrupp"
    },
    "add_group_short": "Grupp",
    "failed_to_load": "Inläsning av tjänstegrupper misslyckades",
    "activate": "Aktivera {{name}}",
    "deactivate": "Inaktivera {{name}}",
    "list": {
      "name": "Namn",
      "active": "Aktiv",
      "yes": "Ja",
      "no": "Nej"
    },
    "card": {
      "actions_aria": "Åtgärder för tjänstegruppen {{name}}",
      "in_use": "I bruk",
      "yes": "Ja",
      "no": "Nej",
      "duration": "Varaktighet",
      "margin": "Marginal",
      "holes9": "9h",
      "holes18": "18h",
      "before": "före",
      "after": "efter",
      "min": "min"
    },
    "form": {
      "create_title": "Ny tjänstegrupp",
      "edit_title": "Redigera tjänstegrupp",
      "section_title": "Inställningar för tjänstegrupp",
      "name": "Namn",
      "icon": "Gruppikon",
      "icons": {
        "carFront": "Bil",
        "bicycle": "Cykel",
        "gear": "Kugghjul",
        "star": "Stjärna",
        "person": "Person"
      },
      "active": "I bruk",
      "duration9": "Bokningens varaktighet 9 hål (min)",
      "duration18": "Bokningens varaktighet 18 hål (min)",
      "margin_before": "Bokningsmarginal före bokning (min)",
      "margin_after": "Bokningsmarginalen efter bokning (min)",
      "terms": "Bokningsvillkor (visas för spelaren vid bokning)",
      "name_required": "Namn är obligatoriskt",
      "created": "Tjänstegrupp skapad",
      "updated": "Tjänstegrupp uppdaterad",
      "deleted": "Tjänstegrupp borttagen",
      "load_failed": "Det gick inte att ladda tjänstegruppen",
      "save_failed": "Sparandet misslyckades",
      "delete_failed": "Borttagningen misslyckades",
      "delete_confirm_header": "Ta bort tjänstegrupp",
      "delete_confirm_body": "Vill du verkligen ta bort tjänstegruppen {{name}}?"
    },
    "units": {
      "section_title": "Tjänster",
      "add_button": "Lägg till tjänst",
      "name": "Namn",
      "active": "Aktiv",
      "reservations": "Bokningar",
      "reservations_title": "{{count}} kommande bokningar",
      "name_placeholder": "Tjänstens namn",
      "save": "Spara",
      "empty": "Inga tjänster",
      "created": "Tjänst skapad",
      "updated": "Tjänst uppdaterad",
      "activated": "{{name}} aktiverad",
      "deactivated": "{{name}} inaktiverad",
      "deleted": "Tjänst borttagen",
      "name_required": "Tjänstens namn är obligatoriskt",
      "load_failed": "Det gick inte att ladda tjänsterna",
      "save_failed": "Det gick inte att spara tjänsten",
      "delete_failed": "Det gick inte att ta bort tjänsten",
      "delete_confirm_header": "Ta bort tjänst",
      "delete_confirm_body": "Vill du verkligen ta bort tjänsten {{name}}?",
      "form": {
        "create_title": "Ny tjänst",
        "edit_title": "Redigera tjänst"
      }
    }
  }
}
